import { temAcesso } from '@/shared/auth/temAcesso'

const ExcluirComprometimentosEmLote = () =>
    import('./ExcluirComprometimentosEmLote.vue')

export default {
    path: 'comprometimentos',
    name: 'Admin_Comprometimentos',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: 'excluir-em-lote',
            name: 'Admin_Comprometimento_ExcluirEmLote',
            component: ExcluirComprometimentosEmLote,
            beforeEnter: (to, from, next) => {
                if (temAcesso('ADMIN-COMPR-00')) {
                    next()
                }
            }
        }
    ]
}
